var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16098_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0002C32 7.16374 24.8365 0.000244141 16 0.000244141C7.1635 0.000244141 0 7.16362 0 16.0002C0 23.9862 5.851 30.6056 13.5 31.8059V20.6252H9.4375V16.0002H13.5V12.4752C13.5 8.46525 15.8888 6.25025 19.5434 6.25025C21.294 6.25025 23.125 6.56275 23.125 6.56275V10.5002H21.1075C19.1198 10.5002 18.5 11.7336 18.5 12.999V16.0002H22.9375L22.2281 20.6252H18.5V31.8059C26.149 30.6056 32 23.9864 32 16.0002Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2281 20.6252L22.9375 16.0002H18.5V12.999C18.5 11.7335 19.1199 10.5002 21.1075 10.5002H23.125V6.56274C23.125 6.56274 21.294 6.25024 19.5434 6.25024C15.8888 6.25024 13.5 8.46524 13.5 12.4752V16.0002H9.4375V20.6252H13.5V31.8059C14.327 31.9355 15.1629 32.0005 16 32.0002C16.8371 32.0005 17.673 31.9355 18.5 31.8059V20.6252H22.2281Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16098_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.df76c59ed1182ff8c87c5e209be84b04.svg";
export { ForwardRef as ReactComponent };